import React, { Component } from 'react';
import './ClassSection.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as UserWiseActions from '../../Actions/UserWiseSearch';
import * as sharedActions from '../../Actions/sharedActions';
import UserSubComponent from './UserSubComponent';
class UserWiseSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dummy: [],
			sessions: []
		};
	}
	static getDerivedStateFromProps(nextProps, prevState) {
		if (
			prevState.dummy !== nextProps.selectStudent ||
			prevState.sessions !== nextProps.selectSession
		) {
			return {
				dummy: nextProps.selectStudent,
				sessions: nextProps.selectSession
			};
		}
		return null;
	}
	componentDidMount() {
		this.props.sharedActions
			.gAllData(
				'/api/Session',
				this.props.UserWiseActions.getSessionsForUserWise
			)
			.then(success => {})
			.catch(error => {});
		this.props.sharedActions
			.gAllData(
				'/api/ClassSection',
				this.props.UserWiseActions.getStudentForUserWise
			)
			.then(success => {})
			.catch(error => {});
	}
	render() {
		const { classList } = this.state.dummy;
		const { section } = this.state.dummy;
		const { session } = this.state.sessions;
		console.log('Sessions', session);
		return (
			<div>
				<div style={{ justifyContent: 'center', textAlign: 'center' }}>
					<UserSubComponent
						data={classList}
						Document={section}
						session={session}
					/>
				</div>
			</div>
		);
	}
}
function mapDispatchToProps(dispatch) {
	return {
		sharedActions: bindActionCreators(sharedActions, dispatch),
		UserWiseActions: bindActionCreators(UserWiseActions, dispatch)
	};
}

function mapStateToProps(state) {
	return {
		userData: state.setUserReducer.users,
		selectStudent: state.setUserWiseReducer.selectStudent,
		selectSession: state.setUserWiseReducer.selectSession
	};
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(UserWiseSearch);
